
export const Breakpoints = {
	BASE: 1,
	SM: 575,
	MD: 768,
	LG: 992,
	XL: 1200,
	XXL: 1600
}
